/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import * as types from '../constants/ActionTypes';
import { getTenantMembers } from '../../Services/services/DashboardAPIs';

const loadTenantMembersRequest = () => ({
  type: types.LOAD_TENANT_MEMBERS_REQUEST,
});
const loadTenantMembersSuccess = data => ({
  type: types.LOAD_TENANT_MEMBERS_SUCCESS,
  data,
});
const loadTenantMembersFailure = error => ({
  type: types.LOAD_TENANT_MEMBERS_FAILURE,
  error,
});

export const loadTenantMembers = () => dispatch => {
  dispatch(loadTenantMembersRequest());
  return getTenantMembers().then(
    json => dispatch(loadTenantMembersSuccess(json)),
    error => dispatch(loadTenantMembersFailure(error))
  );
};
